import React, {useCallback, useEffect, useRef, useState} from 'react';
import HomeStyle from './style';

import Sort from "../../Assets/sort.svg";

// -- redux
import {connect} from "react-redux";
import {GetServiceRequest} from "../../Redux/Actions/ServiceRequestAction"
import Loader from "../../Container/Loader";

import RightSideBar from '../../Container/RightSidebar';
import {withRouter} from "react-router";

function ServiceRequest(props) {
    const [Open, SetOpen] = useState(false);
    const [Data, SetData] = useState(false);
    const [page, setPage] = useState(1);
    const [sortBy, setSortBy] = useState(1);
    const [sortType, setSortType] = useState('desc');
    const [hasMore, setHasMore] = useState('');
    const [tableEntries, setTableEntries]=useState([]);

    const observer = useRef();

    const showAMPM = (time) => {
        let AMPM = ''
        let hourStr = ''
        let minStr = ''
        if(time) {
            let hours = parseInt(time.split(":")[0],10)
            let minutes = parseInt(time.split(":")[1],10)
            if(hours > 11) {
                if(hours > 12) hours = hours - 12
                AMPM = 'PM'
            } else {
                AMPM = 'AM'
                if(hours === 0) hours = 12
            }
            if(hours < 10){
                hourStr= '0'+String(hours)
            }else {
                hourStr=String(hours)
            }
            if(minutes < 10){
                minStr= '0'+String(minutes)
            }else {
                minStr = String(minutes)
            }
            return(hourStr + ' : '+ minStr+' '+AMPM)
        } else {
            return time
        }
    };

    const dateFormatter = (dateStr) => {
        if(dateStr){
            let dd = dateStr.split('-')[2];
            let mm = dateStr.split('-')[1];
            let yy = dateStr.split('-')[0];
            return `${mm}/${dd}/${yy}`
        } else {
            return ''
        }
    };
    
    const lastItem = useCallback(node => {
        if(props.loading) return;
        if(observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if(entries[0].isIntersecting && hasMore){
                setPage(prevPage => prevPage + 1)
            }
        });
        if(node) observer.current.observe(node)
    }, [props.loading, hasMore]);

    useEffect(() => {
        if(props.search.length > 2){
            const data = {
                page: page,
                sort_by: sortBy,
                sort_type: sortType,
                search_key: props.search
            };
            props.GetServiceRequest(data);
        } else {
            const data = {
                page: page,
                sort_by: sortBy,
                sort_type: sortType,
            };
            props.GetServiceRequest(data);
        }
    }, [page, sortBy, sortType, props.search]);

    useEffect(() => {
        if(props.data && props.data.data && props.data.data.data){
            props.total(props.data.data.total_records);
            setTableEntries(prevData => {
                return [...new Set([...prevData, ...props.data.data.data])]
            });
            setHasMore(props.data.data.data.length > 0)
        }
    }, [props.data]);

    useEffect(() => {
        setTableEntries([]);
        setPage(1)
    }, [props.search, sortBy, sortType]);
    
    useEffect(() => {
        props.clear('clear');
        setTimeout(function () {
            props.clear('');
        }, 1000)
    },[]);

    const handleEdit = (e, id,title) => {
        e.preventDefault();
        SetData({id: id, title: title});
        SetOpen(true)
    };

    const handleSort = (e, type) => {
        e.preventDefault();
        if(type === 'date'){
            setSortBy('1');
            sortType === 'asc' ? setSortType('desc') : setSortType('asc')
        } else if(type === 'user_id'){
            setSortBy('2');
            sortType === 'asc' ? setSortType('desc') : setSortType('asc')
        } else if(type === 'user_name'){
            setSortBy('3');
            sortType === 'asc' ? setSortType('desc') : setSortType('asc')
        } else if(type === 'service_title'){
            setSortBy('4');
            sortType === 'asc' ? setSortType('desc') : setSortType('asc')
        }
    };

    return (
        <>
            {props.loading && <Loader/>}
            <div className="ml-4 mr-2">
                <div className="module-table-wrap table-responsive">
                    <div className="table-wrap" style={{ height: 'calc(100vh - 110px)' }}>
                        <table className="table table-bordered">
                            <thead className='text-grey-6'>
                            <tr>
                                <th scope="col" className='dark-background cursor-pointer'>
                                    <div
                                        onClick={(e) => handleSort(e, 'date')}
                                        className="d-flex justify-content-between">
                                        <span className='f-16'>Date</span>
                                        <img src={Sort} alt="sort" className="ml-2"/>
                                    </div>
                                </th>
                                <th scope="col" style={{width:"200px"}} className='dark-background cursor-pointer'>
                                    <div

                                        className="d-flex justify-content-between">
                                        <span className='f-16'>User Id</span>

                                    </div>
                                </th>
                                <th scope="col" className='dark-background cursor-pointer'>
                                    <div
                                        className="d-flex justify-content-between">
                                        <span className='f-16'>User Name</span>

                                    </div>
                                </th>
                                <th scope="col" className='dark-background cursor-pointer'>
                                    <div
                                        onClick={(e) => handleSort(e, 'service_title')}
                                        className="d-flex justify-content-between">
                                        <span className='f-16'>Service Title</span>
                                        <img src={Sort} alt="sort" className="ml-2"/>
                                    </div>
                                </th>
                                <th scope="col" className='dark-background'>
                                    <div className="d-flex justify-content-between">
                                        <span className='f-16'>Onfleet Status</span>
                                    </div>
                                </th>
                                <th scope="col" className='dark-background'>
                                    <div className="d-flex justify-content-between">
                                        <span className='f-16'>Detail</span>
                                    </div>
                                </th>
                            </tr>
                            </thead>
                            <tbody className='light-grey-background text-white'>
                            {tableEntries.length > 0 ? tableEntries.map((item,index)=>{
                                return <tr key={index}>
                                    {tableEntries.length === index + 1 ?
                                        <td ref={lastItem}>
                                        {item.date_of_submission && <p className='text-white pl-2 pr-2 mb-0'>{dateFormatter(item.date_of_submission.split(" ")[0])}</p>}
                                        {item.date_of_submission && <p className='text-white pl-2 pr-2 mb-0'>{showAMPM(item.date_of_submission.split(" ")[1])}</p>}
                                        {item.date_of_submission && <p className='text-white pl-2 pr-2 mb-0'>{item.date_of_submission.split(" ")[2]}</p>}
                                        </td> :
                                        <td>
                                        {item.date_of_submission && <p className='text-white pl-2 pr-2 mb-0'>{dateFormatter(item.date_of_submission.split(" ")[0])}</p>}
                                        {item.date_of_submission && <p className='text-white pl-2 pr-2 mb-0'>{showAMPM(item.date_of_submission.split(" ")[1])}</p>}
                                        {item.date_of_submission && <p className='text-white pl-2 pr-2 mb-0'>{item.date_of_submission.split(" ")[2]}</p>}
                                        </td>
                                    }
                                    <td style={{width:"200px"}}>
                                        <span className='f-16'>
                                            {item.user_id}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='f-16'>
                                            {item.full_name}
                                        </span>
                                    </td>
                                    <td>
                                        <span className='f-16'>
                                            {item.title}
                                        </span>
                                    </td>
                                    {/* <td>
                                        <span className='f-16'>
                                            {item.date_of_submission.split(' ')[1]}
                                        </span>
                                    </td> */}
                                    <td>
                                        {item.onfleet_track_url && <a target='_blank' href={item.onfleet_track_url}>
                                            <span className="f-16 text-green pl-2">
                                                View Status
                                            </span>
                                        </a>}
                                    </td>
                                    <td>
                                        <span className="f-16 text-green cursor-pointer pl-2 pr-3" onClick={(e)=> handleEdit(e, item.id, item.title)}>
                                            View Details
                                        </span>
                                    </td>
                                </tr>
                            })
                                :
                                <tr>
                                    <td colSpan='9' className='text-center border-0'>
                                        <p className='m-0 text-white'>Nothing found</p>
                                    </td>
                                </tr>
                            }
                            </tbody>
                        </table>
                        {props.table_loading &&
                            <div className='text-center w-100'>
                                <p className='text-white mt-5 font-weight-bold'>Loading...</p>
                            </div>
                        }
                        <HomeStyle/>
                    </div>
                </div>
                <RightSideBar
                    Type='Edit'
                    data={Data}
                    sidebar={Open}
                    close={() =>  SetOpen(false)}
                />
            </div>
        </>
    );
}

const mapStateToProps = ({ServiceRequestReducer}) => {
    const { loading, data} = ServiceRequestReducer;
    return { loading, data}
};

const mapDispatchToProps = {
    GetServiceRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ServiceRequest));